import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {Button} from "primeng/button";
import {NativeAppService} from "../native-app.service";

@Component({
  selector: 'homey-mandatory-update',
  imports: [
    Button
  ],
  templateUrl: './mandatory-update.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MandatoryUpdateComponent {
  protected readonly nativeService = inject(NativeAppService);

  protected onUpdateClick(): void {
    this.nativeService.openStorePage();
  }
}
